import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';
import { l as layoutStyles } from '../../layout.module-63c375e5.js';

var desktopStyles = {"footer":"modal__footer_1iqte","sticky":"modal__sticky_1iqte","fullscreen":"modal__fullscreen_1iqte","size-500":"modal__size-500_1iqte","size-600":"modal__size-600_1iqte","size-800":"modal__size-800_1iqte","size-1140":"modal__size-1140_1iqte"};
require('./desktop.css')

var styles = {"footer":"modal__footer_7k4oh","sticky":"modal__sticky_7k4oh","highlighted":"modal__highlighted_7k4oh"};
require('./index.css')

var mobileStyles = {"footer":"modal__footer_19htl","sticky":"modal__sticky_19htl"};
require('./mobile.css')

var Footer = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, sticky = _a.sticky, _c = _a.layout, layout = _c === void 0 ? 'start' : _c, gap = _a.gap;
    var _d = useContext(ModalContext), footerHighlighted = _d.footerHighlighted, setHasFooter = _d.setHasFooter;
    var _e = useContext(ResponsiveContext), size = _e.size, view = _e.view, dataTestId = _e.dataTestId;
    useEffect(function () {
        setHasFooter(true);
    }, [setHasFooter]);
    return (React.createElement("div", { "data-test-id": getDataTestId(dataTestId, 'footer'), className: cn(styles.footer, className, layoutStyles[layout], gap && layoutStyles["gap-".concat(gap)], (_b = {},
            _b[styles.highlighted] = sticky && footerHighlighted,
            _b[styles.sticky] = sticky,
            _b[desktopStyles.footer] = view === 'desktop',
            _b[desktopStyles.sticky] = view === 'desktop' && sticky,
            _b[desktopStyles[SIZE_TO_CLASSNAME_MAP[size]]] = view === 'desktop',
            _b[mobileStyles.footer] = view === 'mobile',
            _b[mobileStyles.sticky] = view === 'mobile' && sticky,
            _b)) }, children));
};

export { Footer };
